import React, { Component } from 'react';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import Message from '../../partials/Message';
import Project from './Project.js';

export default class Transactions extends Component {
    state = {
        message: '',
        data: {}
    }

    constructor(props) {
        super(props);

        this.previous = this.previous.bind(this);
        this.next = this.next.bind(this);
        this.fetch = this.fetch.bind(this);
    }

    fetch() {
        axios.get(API_URL+'/admin/sales')
            .then(response => {
                this.setState({ 
                    data: response.data,
                    sales: response.data.data
                });
            });
    }

    componentDidMount() {
        this.fetch();
    }

    previous(event) {
        event.preventDefault();

        axios.get(this.state.data.prev_page_url)
            .then(response => {
                this.setState({
                    data: response.data,
                    sales: response.data.data
                })
            });
    }

    next(event) {
        event.preventDefault();

        axios.get(this.state.data.next_page_url)
            .then(response => {
                this.setState({
                    data: response.data,
                    sales: response.data.data
                })
            });
    }

    render() {
        const { data, sales } = this.state;
        const self = this;

        return (
            <div>
                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                    </div>
                </div>

                <Message message={ this.state.message } />

                <div className="container">
                    <div className="content">
                        <h1>Försäljning</h1>

                        { sales && sales.length > 0 &&
                            <div className="block">
                                <div className="header">
                                    <h4>Försäljning</h4>
                                </div>

                                <div className="body">
                                    <ul className="has-icons compressed">
                                        { Object.keys(sales).map(function(key) {
                                            return (
                                                <Project key={ key } project={ sales[key] } update={ self.fetch } />
                                            )
                                        }) }
                                    </ul>

                                    <div className="pagination">
                                        <div className="pagination-wrapper">
                                            { data.current_page > 1 ? (
                                                <a className="prev" onClick={ this.previous }>&nbsp;</a>
                                            ) : (
                                                <a className="prev disabled">&nbsp;</a>
                                            ) }
                                            <span className="info">
                                                { data.current_page } / { data.last_page } 
                                            </span>
                                            { data.current_page < data.last_page ? (
                                                <a className="next" onClick={ this.next }>&nbsp;</a>
                                            ) : (
                                                <a className="next disabled">&nbsp;</a>
                                            ) }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Sales/index.js